import React, { FC } from 'react';
import { graphql, Link } from 'gatsby';

import GatsbyImage from 'components/common/GatsbyImage';
import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';
import useScreenRecognition from 'hooks/useScreenRecognition';
import { getStringWithoutTags } from 'utils';

import { IArticleCardsProps } from './model';

import './ArticleCards.scss';

const ArticleCards: FC<IArticleCardsProps> = ({ articleList }) => {
  const { isMobile } = useScreenRecognition();

  return (
    <div className="article-cards">
      {articleList.map(({ link, title, image, alt, text, shortText }) => (
        <Link to={link} className="article-cards__link" key={title}>
          {image?.fallbackUrl && !isMobile ? (
            <div className="article-cards__image-wrapper">
              <GatsbyImage className="article-cards__image" fluid={image} alt={alt} />
            </div>
          ) : null}
          <div className="article-cards__body">
            <DangerouslySetInnerHtml className="article-cards__title" element="h3" html={title} />
            <DangerouslySetInnerHtml
              className="article-cards__text"
              html={
                isMobile ? getStringWithoutTags(text || shortText).slice(0, 140) : text || shortText
              }
            />
          </div>
        </Link>
      ))}
    </div>
  );
};

export const query = graphql`
  fragment FragmentArticleListItem on TArticleListItem {
    title
    text
    url
    image {
      ...FragmentGatsbyImage
    }
    imageAlt
  }
`;

export default ArticleCards;
